module.exports = __webpack_public_path__ + "img/1 (145).630a9feb.png";